exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftv-magneto--ui * {\n  box-sizing: border-box !important;\n  outline: 0;\n}\n\n.ftv-magneto--foreground::before {\n  content: '';\n  position: absolute;\n  background: rgba(0, 0, 0, 0.2);\n  width: 100%;\n  height: 100%;\n}\n\n.ftv-magneto-pointer>*,\n.ftv-magneto-pointer *,\n.ftv-magneto-pointer {\n  cursor: pointer !important;\n}\n\n.ftv-magneto-underline-on-hover:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
